// RoleRulesEditor.tsx
import { PRIVATE_ROUTE_CATALOG } from "@/security/routes.catalog";
import { ROLE_ACTION_CATALOG } from "@/security/actions.catalog";
import FeatureChecklistEditor from "@components/forms/FeatureChecklistEditor";

export type RoleRules = Record<string, boolean>;

type Props = {
    initialRules?: RoleRules;
    onChange?: (rules: RoleRules) => void;
    readOnly?: boolean;
};

export default function RoleRulesEditor({ initialRules, onChange, readOnly }: Props) {
    return (
        <FeatureChecklistEditor
            nodes={[...PRIVATE_ROUTE_CATALOG, ...ROLE_ACTION_CATALOG]}
            initialValues={initialRules}
            onChange={onChange}
            readOnly={readOnly}
            defaultValue={false}
        />
    );
}
